import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { callApi } from "../../../lib/apiCaller";

// Async thunk
export const fetchCustomerConfig = createAsyncThunk(
  "booking/fetchCustomerConfig",
  async (_, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "FETCH_USER_CONFIG",
        method: "GET",
        pathParam: "CUSTOMER",
        useContent: true,
      });
      console.log(res);
      return res?.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to fetch customer config",
      );
    }
  },
);

// Initial state
const initialState = {
  config: null, // will hold the config object
  isLoading: false,
  error: null,
};

// Slice
const userConfigSlice = createSlice({
  name: "userConfig",
  initialState,
  reducers: {
    setUserConfig(state, action) {
      state.config = action.payload?.value || null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerConfig.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCustomerConfig.fulfilled, (state, action) => {
        state.config = action.payload.value || null;
        state.isLoading = false;
      })
      .addCase(fetchCustomerConfig.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load config";
      });
  },
});

// Exports
export const { setUserConfig } = userConfigSlice.actions;
export default userConfigSlice.reducer;
